import { Builder } from '@builder.io/react';

import { EventsDetails, EventsHero } from './';

Builder.registerComponent(EventsHero, {
  name: 'EventsHero',
  inputs: [
    {
      name: 'event',
      type: 'reference',
      model: 'event',
      defaultValue: {
        '@type': '@builder.io/core:Reference',
        id: 'b9435187f0054bdabc7dfbfa4d4efabd',
        model: 'event'
      }
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Get Started',
              href: '/sales',
              type: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'type',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary']
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'default',
              enum: ['default', 'transparent']
            }
          ]
        },
        {
          name: 'hubspotModal',
          type: 'object',
          subFields: [
            {
              name: 'formId',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            }
          ]
        }
      ]
    }
  ]
});

Builder.registerComponent(EventsDetails, {
  name: 'EventsDetails',
  inputs: [
    {
      name: 'content',
      type: 'richText'
    },
    {
      name: 'images',
      type: 'list',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpg', 'jpeg', 'png']
        },
        {
          name: 'alt',
          type: 'string'
        }
      ]
    }
  ]
});
